import React, { useState, useRef, useImperativeHandle } from "react";
import { Tooltip, theme, Modal } from "antd";
import { ClearOutlined, ExclamationCircleOutlined, } from "@ant-design/icons";
import ErrorMessages from "../../common/ErrorMessages";
import TSTable from "../../common/TSTable";
import { POST } from "../../frameworks/HttpClient";
import { dateToHumanString, formatComma } from "../../frameworks/Util";
import { URL_TANK } from "../../constants/urls"; // test รอ api
import PurchaseCTTStockListViewModal from "./PurchaseCTTStockListViewModal";
import CustomDeleteConfirmButton from "../../common/CustomDeleteConfirmButton";
import PurchaseCTTStockLogModal from "./PurchaseCTTStockLogModal";

const PurchaseCTTStockListView = React.forwardRef((props, ref) => {
  const [openPurchaseCTTStockListViewModal, setOpenPurchaseCTTStockListViewModal] = useState(false);
  const [target, setTarget] = useState(null);
  const [logTarget, setLogTarget] = useState(null);
  const tableRef = useRef(null);
  const [errorMessages, setErrorMessages] = useState(null);

  const {
    token: { colorPrimary },
  } = theme.useToken();

  useImperativeHandle(ref, () => ({
    fetchTable: refreshData,
  }));

  const refreshData = async () => {
    if (tableRef.current) {
      setErrorMessages(null);
      try {
        await tableRef.current.fetchWithoutResetPage();
      } catch (error) {
        setErrorMessages(error.errorMessages);
      }
    }
  };

  const handleDelete = async (id) => {
    if (!id) {
      return;
    }
    setErrorMessages(null);
    try {
      await POST(`${URL_TANK.IMPORT_CONCENTRATE_STOCK}${id}/close/`);
      refreshData();
    } catch (error) {
      setErrorMessages(error.errorMessages);
    }
  };

  const columns = [
    {
      title: "Action",
      dataIndex: "",
      width: 80,
      key: "action",
      align: "center",
      render: (_, record) =>
        (
          <div onClick={(e) => e.stopPropagation()}>
            <CustomDeleteConfirmButton
              onOk={ async() => {
                await handleDelete(record.id)
                refreshData();
              }}
              onConfirm={() => refreshData()}
              icon={<ClearOutlined />}
              override={colorPrimary}
              title={`ล้างล็อตนำเข้า ${record.lot_no}`}
              content={'คุณต้องการล้างล็อตนำเข้าน้ำยางข้นนี้ใช่หรือไม่ ?'}
            />
          </div>
        ),
    },
    {
      title: "วันที่นำเข้า",
      dataIndex: "created",
      key: "created",
      align: "center",
      render: (value) => dateToHumanString(value)
    },
    {
      title: "ล็อตนำเข้า",
      dataIndex: "source_lot_no",
      key: "source_lot_no",
      align: "center",
      searcher : true,
    },
    {
      title: "Lot No.",
      dataIndex: "lot_no",
      key: "lot_no",
      align: "center",
      searcher : true,
    },
    {
      title: "สินค้า",
      dataIndex: "product_name",
      key: "product_name",
      align: "center",
      searcher: true,
    },
    {
      title: "น้ำหนักรับเข้า",
      dataIndex: "weight",
      key: "weight",
      align: "center",
      render: (value) => <center>{formatComma(value)}</center>
    },
    {
      title: "น้ำหนักคงเหลือ",
      dataIndex: "current_weight",
      key: "current_weight",
      align: "center",
      render: (value, original) => <center>
        <a onClick={() => setLogTarget(original.id)}>{formatComma(value)}</a>
      </center>
    },
    {
      title: "เลขที่แจ้งผลิต",
      dataIndex: "order_ref_no",
      key: "order_ref_no",
      align: "center",
      render : (value) => value ? value : '-'
    },
    {
      title: "บริษัท-ผู้นำเข้า",
      dataIndex: "supplier_name",
      key: "supplier_name",
      align: "center",
      searcher: true,
    },
  ];

  return (
    <div>
      <ErrorMessages message={errorMessages}/>
      <TSTable
        columns={columns}
        size="small"
        url={URL_TANK.IMPORT_CONCENTRATE_STOCK}
        params={{ is_closed : false   }}
        ref={tableRef}
      />
      <PurchaseCTTStockListViewModal
        open={openPurchaseCTTStockListViewModal} 
        onClose={() => {
          setOpenPurchaseCTTStockListViewModal(false);
          setTarget(null);
        }}
        onUpdate={() => {
          setOpenPurchaseCTTStockListViewModal(false);
          setTarget(null);
          refreshData();
        }}
        target={target}
      />
      <PurchaseCTTStockLogModal
        open={logTarget ? true : false}
        onClose={() => {
          setLogTarget(null)
        }}
        target={logTarget}
      />
    </div>
  );
});

export default PurchaseCTTStockListView;